module.exports = __webpack_public_path__ + "img/car.back.796df910.png";